import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const { Types: KioskTypes, Creators: KioskActions } = createActions(
  {
    setKioskMode: ['isEnabled'],
    setCurrentKioskBySlug: ['slug'],
    setCurrentKioskId: ['id'],
  },
  { prefix: 'KIOSK_' }
);

export const INITIAL_STATE = Immutable({
  isKioskMode: false,
  currentKioskId: null,
});

const handleKioskModeSet = (state, { isEnabled }) => state.set('isKioskMode', isEnabled);
const handleKioskIdSet = (state, { id }) => state.set('currentKioskId', id);

export const reducer = createReducer(INITIAL_STATE, {
  [KioskTypes.SET_KIOSK_MODE]: handleKioskModeSet,
  [KioskTypes.SET_CURRENT_KIOSK_ID]: handleKioskIdSet,
});
